<nav mat-tab-nav-bar class="responsive-nav">
    <a mat-tab-link [href]="navLinks[0].path">
        <img src="../../../assets/images/logo.png" alt="Home" />
    </a>
    @if (isLoggedIn()) {
    <button mat-button [matMenuTriggerFor]="menu">Menu</button>
    }
    <mat-menu #menu="matMenu">
        @for (link of navLinks | callbackFilter:filterNavigation; track link.path) {
        <button mat-menu-item [routerLink]="[link.path]" routerLinkActive="active-menu-item"
            [routerLinkActiveOptions]="{exact: true}" (click)="activeRouter(link)"
            (isActiveChange)="$event ? activeRouter(link) : null"> {{link.label}} </button>
        }
    </mat-menu>
    @if (isLoggedIn()) {
    <div class="vertical"></div>
    }
    @if (isLoggedIn()) {
    <button mat-button class="activeLabel">
        {{this.loginStateService.activeLabel}}
    </button>
    }

    <span class="spacer"></span>

    @if (isLoggedIn()) {
    <div class="buttons">
        <div class="brand-chooser-button">
            <button mat-stroked-button [disabled]="!brands || brands.length < 1" color="primary"
                (click)="openBrand($event)">
                <span>{{currentBrand?.brand}}</span>
                <mat-icon>expand_more</mat-icon>
            </button> 
        </div>
        <div class="fmSystemList-chooser-button">
            <button mat-stroked-button [disabled]="!fmSystemLists || fmSystemLists.length < 1" color="primary"
                (click)="openFmSystemList($event)">
                <span>{{currentFmSystemList?.name}}</span>
                <mat-icon>expand_more</mat-icon>
            </button>
        </div>
        <form class="example-form" [formGroup]="beComponentForm">
            <mat-form-field subscriptSizing="dynamic" class="inp">
                <mat-select formControlName="myControl" placeholder={{currentClient?.clientName}}
                    (click)="open($event)">
                    <div class="fixed">
                        <div class="mat-form-field-wrapper mdc-text-field" style="width: 100%; height: 100%; padding: 0 10px;">
                            <div class="mat-form-field-flex d-flex align-items-center h-100">
                                <div class="mat-form-field-prefix">
                                    <i class="fa fa-search"></i>
                                </div>
                                <div class="mat-form-field-infix" style="flex: 1;">
                                    <input matInput class="mat-input-element mdc-text-field__input" [formControl]="myControl"
                                        (input)="lookup(inputFilter.value);" #inputFilter (keydown)="_handleKeydown($event)"
                                        style="padding-left: 10px; width: 100%; border: none; outline: none; background: transparent;">
                                    <span class="mat-form-field-label-wrapper"></span>
                                </div>
                                <div class="mat-form-field-suffix">
                                    <mat-icon class="close ms-auto" aria-hidden="true" (click)="clean(inputFilter);">close</mat-icon>
                                </div>
                            </div>
                            <div class="mat-form-field-underline">
                                <span class="mat-form-field-ripple"></span>
                            </div>
                            <div class="mat-form-field-subscript-wrapper">
                                <div class="mat-form-field-hint-wrapper">
                                    <div class="mat-form-field-hint-spacer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="options-container">
                        @for (clients of filteredOptions | async; track clients.clientId) {
                        <mat-option class="client" (onSelectionChange)="selectedOption($event,clients.clientId)">
                            <span> {{clients.clientName}}</span>
                        </mat-option>
                        }
                    </div>
                    
                </mat-select>
            </mat-form-field>
        </form>
        <div class="logout-button">
            <button mat-stroked-button color="primary" (click)="logout()">Log Out</button>
        </div>
    </div>
    }
</nav>

@if (loading) {
<div class="loading-shade">
    @if (loading) {
    <mat-spinner></mat-spinner>
    }
</div>
}